import Success from "@/views/public/success/stripe/Success.vue";

export default {
  path: "/success/:sessionId",
  name: "success",
  component: Success,
  props: true
};
